import { ApolloError } from '@apollo/client';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Field, Textarea, FluentProvider, webLightTheme } from '@fluentui/react-components';
import React from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import { IProcessTemplate, IProcessTemplateInput } from '../../utils/types/IProcessTemplate';
import LoadingErrorMessage from '../common/errorContent/LoadingErrorMessage';

interface IProcessTemplateFormProps {
  mutationLoading: boolean;
  mutationError: ApolloError;
  processTemplate: IProcessTemplate;
  onSubmit: (processTemplateInput: IProcessTemplateInput) => void;
  form: UseFormMethods<Record<string, unknown>>;
}

const ProcessTemplateEditForm = (props: IProcessTemplateFormProps): JSX.Element => {
  const { processTemplate, form, mutationError, mutationLoading, onSubmit } = props;
  const { control, errors, setValue, handleSubmit } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 5 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <LoadingErrorMessage error={mutationError} loading={mutationLoading} />
          <Controller
            control={control}
            name="name"
            defaultValue={processTemplate?.name}
            rules={{
              maxLength: {
                value: 50,
                message: 'Input is greater than the maximum character limit of 50.',
              },
              required: 'Please enter a name',
            }}
            render={({ onChange, onBlur, value, name, ref }) => (
              <Field label="Name" required validationMessage={errors?.name?.message}>
                <Textarea
                  id="name"
                  value={value}
                  name={name}
                  ref={ref}
                  onBlur={onBlur}
                  onChange={(ev, textareaData) => {
                    onChange(textareaData.value);
                    setValue('name', textareaData.value);
                  }}
                  resize="none"
                />
              </Field>
            )}
          />
          <Controller
            control={control}
            name="description"
            defaultValue={processTemplate?.description}
            rules={{
              maxLength: {
                value: 1000,
                message: 'Input is greater than the maximum character limit of 1000.',
              },
              required: 'Please enter a description',
            }}
            render={({ onChange, onBlur, value, name, ref }) => (
              <Field label="Description" required validationMessage={errors?.description?.message}>
                <Textarea
                  id="description"
                  value={value}
                  name={name}
                  ref={ref}
                  onBlur={onBlur}
                  onChange={(ev, textareaData) => {
                    onChange(textareaData.value);
                    setValue('description', textareaData.value);
                  }}
                  resize="none"
                />
              </Field>
            )}
          />
        </form>
      </Stack>
    </FluentProvider>
  );
};

export default ProcessTemplateEditForm;
